import base from 'components/base'
import mainMenu from 'components/mainMenu'
import urlJoin from 'url-join'
import $ from 'jquery'

class searchInput extends base
{
  elements = {
    container: null,
    form: null,
    input: null,
    siteContent: null
  }

  constructor(element)
  {
    super()

    this.elements.container = $(element).get(0)
    this.elements.form = $(this.elements.container).find('form').get(0)
    this.elements.input = $(this.elements.container).find('input[name="search"]').get(0)
    this.elements.siteContent = $('#site-content').get(0)

    this.bindEvents()
  }

  bindEvents()
  {
    $(this.elements.form).on('submit.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.search()
    })
  }

  search()
  {
    let searchTerm = $(this.elements.input).val()
    let url = urlJoin($(this.elements.form).attr('action'), encodeURIComponent(searchTerm))
    mainMenu.changePage(url, {
      element: this.elements.container,
      errorsAfter: $(this.elements.input).parent().get(0),
      callback: (query) => {
        if(query.status && typeof gtag === 'function')
          gtag('event', 'search', {
            search_term: searchTerm
          })
      }
    })

  }
}

let instances = []

$(document).ready(() =>
{
  let elements = $('.search-input').get()
  for(let element of elements)
    instances.push(new searchInput(element))
})

export default instances



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/searchInput.js